module.exports = "<div id=\"tabImprimir\">\n  <fieldset></fieldset>\n</div>\n\n"